import valueSeriesGroupTableTemplate from './valueSeriesGroupTable.html';
import { TableGroupController} from '../tableGroupController';
import {VALUES, VALUE_SERIES, currencyAccounts, byCountySummary, banks,
    byGroupSummary,
    byAccountSummary
} from '../../../services/arsweb/RoutingPaths';
import { BackendService } from '../../../services/BackendService';
import { reactValueSeriesCols } from './valueSeriesColDefs';
import { AccountService } from '../../../services/AccountService';
import { VALUESERIES_TITLE } from '../../../services/arsweb/TableTitles';
import {TAB_ACCOUNT} from "../../../views/accounts/overview";
import moment from "moment";

/** @ngInject */
export function valueSeriesGroupTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '=',
            groupData: '=',
            dateFilter: '=',
            consolitationcurrency: '=',
            parentController: '='
        },
        templateUrl: valueSeriesGroupTableTemplate,
        controller: ValueSeriesGroupTableController,
        controllerAs: 'vm'
    };
}

const URL = { 'currency': currencyAccounts, 'country': byCountySummary, 'bank': banks, 'group': byGroupSummary,
    'account' : byAccountSummary };

/** @ngInject */
export class ValueSeriesGroupTableController extends TableGroupController {
    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies, new BackendService(userService, VALUE_SERIES), 'valueSeriesGroupTableParams',
            reactValueSeriesCols(userService.fsMainDependencies.$translate, userService, $scope.groupData),
            VALUES, VALUESERIES_TITLE, 'valueSeriesTableParams' + $scope.groupData);
        $scope.isSearching = true;
        this.accountService = new AccountService(userService);
        this.$location = userService.fsMainDependencies.$location;
        this.tableIdPrefix = 'valueSeriesGroupTable';

        $scope.$on('valueSeriesRangeDate.change', () => this.loadGroupTabInfo(this.groups));
        $scope.$on('groupData.change', (a, groups) => this.loadGroupTabInfo(groups));

        this.loadGroupTabInfo($scope.groupData);
    }

    refreshGraph() {
        const selected = Object.keys(this.checkboxes.rows).filter((key) => this.checkboxes.rows[key]);
        this.$rootScope.groupsSelected = this.$scope.dataGroup.filter(v => selected.includes(v.code));
        this.$rootScope.$broadcast('valueSeriesGraphFilter.change', !_.isNil(selected) ? selected : []);
    }

    expandGroupData(item) {
        if (item.$hideTable) {
            this.groups = (this.groups === TAB_ACCOUNT) ? 'loadKey' : this.groups;
            this.groupFilter = { kind: this.groups, code: item.code };
        }
        item.$hideTable = !item.$hideTable;
    }

    loadGroupTabInfo(groups) {
        this.groups = groups;
        this.backendService.service.config.params['dateFilter'] = this.$scope.dateFilter;
         return this.accountService.getUserSummaryData(URL[this.groups]).then(data => {
            this.$scope.dataGroup = data.accountSummaries.map(summary => {
                return {
                    code: this.groups === 'country' ? summary.name : summary.code,
                    kind: this.groups,
                    numberOfAccounts: summary.numberOfAccounts,
                    $hideTable : true
                }
            }).sort((a, b) => (a.numberOfAccounts - b.numberOfAccounts) * -1 ||
                    a.code.toUpperCase().localeCompare(b.code.toUpperCase()));
            this.$scope.isSearching = false;
            this.$rootScope.$broadcast('groupData.selectorData', this.$scope.dataGroup.map(dataG => dataG.code));
        });
    }

    getMasterRowCount(group) {
        const dateRange = this.ftsMainDependencies.$rootScope.dateFilter.dateRange;
        const diffDays = moment(dateRange.upperBound).diff(moment(dateRange.lowerBound),'days',true);
        return group.numberOfAccounts * (Math.round(diffDays) + 1);
    }
}
